import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure32 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        }
         // line: {
        //   stacking: 'normal',
        //   // shared options for all line series
        //
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "2000", "2001", "2002" , "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019",],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 4500,
        min: 0,
        tickInterval: 500,
        format: '{value.dollar}$',
        gridLineWidth: 2,
        floor: 0,
        title: {
          text: "",
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        // //headerFormat: '<div>{point.key}</div>',
        // valueSuffix: '$',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
    series: [
        {
            type: 'column',
            name: 'Régions en développement',
            color: '#ed7d31',
            borderColor: '#a4a4a4',
            borderWidth: 1,
            data: [88.855360, 63.121110, 58.812410, 63.145100, 62.284190, 93.663560, 82.358960, 111.452600, 130.102490, 168.717110, 76.617680, 103.182750, 81.556210, 65.609100, 48.246480, 37.378160, 51.150390, 77.013700, 65.418010, 34.840960]

        },
        {
            type: 'column',
            name: 'Régions développées',
            color: '#5b9bd5',
            data: [2887.614820, 2601.513870, 3276.312130, 3782.681490, 3645.234020, 2640.889980, 2088.635640, 1373.276900, 896.462360, 755.994100, 436.424280, 404.568720, 285.515160, 203.341770, 182.448700, 180.360300, 158.485710, 120.784220, 120.083150, 23.581760]

        },
        {
            type: 'spline',
            name: 'Min Line',
            color: '#a4a4a4',
            dashStyle: 'solid',
            marker: {
                enabled: false
            },
            tooltip: {
                pointFormatter: function () {
                    return '';
                }
            },
            data: [88.85536, 63.12111, 58.81241, 63.1451, 62.28419, 93.66356, 82.35896, 111.4526, 130.10249, 168.71711, 76.61768, 103.18275, 81.55621, 65.6091, 48.24648, 37.37816, 51.15039, 77.137, 65.41801, 34.84096]

        },
        {
            type: 'spline',
            name: 'Max Line',
            color: '#a4a4a4',
            dashStyle: 'solid',
            tooltip: {
                pointFormatter: function () {
                    return '';
                }
            },
            marker: {
                enabled: false
            },
            data: [2887.61482, 2601.51387, 3276.31213, 3782.68149, 3645.23402, 2640.88998, 2088.63564, 1373.2769, 896.46236, 755.9941, 436.42428, 404.56872, 285.51516, 203.34177, 182.4487, 180.3603, 158.48571, 120.78422, 120.8315, 23.58176]

        },
    ]
}